import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  theme => ({
    buttonContainer: {
      textAlign: "right"
    },
    container: {
      background: "#FFFFFF",
      borderRadius: "20px",
      display: "flex",
      gap: `${theme.spacing(2)}px`,
      maxWidth: "425px",
      padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      gap: `${theme.spacing(1)}px`
    },
    title: {
      fontSize: "1.2rem",
      fontWeight: 600
    },
    spanLink: {
      color: "blue",
      textDecoration: "underline",
      cursor: "pointer"
    }
  }),
  { name: "CouponManualSetCode" }
);

export default useStyles;
